// extracted by mini-css-extract-plugin
export default {"container":"Favorite_container__WPw71","content":"Favorite_content__TXObJ","icon":"Favorite_icon__Gm81f","counter":"Favorite_counter__7wV8w","text":"Favorite_text__xBRGY"};